<template>
  <div class="newsInformation" style="margin-top: 20px">
    <el-row :gutter="10">
      <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8" style="padding: 5px">
        <div class="swiper wheel_content">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(item, index) in dataList"
              :key="index"
            >
              <img
                :src="getImgUrl(item.thumbnail)"
                class="imgs"
                @click="newsDetail(item.id)"
              />
            </div>
          </div>
          <div class="swiper-pagination"></div>
        </div>
      </el-col>
      <el-col
        :xs="24"
        :sm="12"
        :md="12"
        :lg="8"
        :xl="8"
        style="padding: 20px 10px"
      >
        <div class="newsList">
          <div class="newsList_title common_display">
            <p style="padding-bottom: 5px">
              <span
                class="newsTitleImgSrc common_backgroundImg"
                :style="'background-image:url(' + news.newsTitleImgSrc + ')'"
              ></span>
              <span style="font-size: 18px">{{ news.newsTitle }}</span>
            </p>
            <p style="padding-top: 5px">
              <router-link :to="news.morePath">
                <a style="color: #b93229; cursor: pointer; font-size: 14px"
                  >查看更多&gt;</a
                >
              </router-link>
            </p>
          </div>
          <p class="line"></p>
          <div class="newsList_content">
            <ul>
              <li
                class="common_display"
                v-for="(items, index) in newsList"
                :key="index"
              >
                <i class="radius"></i>
                <!-- <a :href="items.newsPath" class="newsList_des common_text">{{items.news_subject}}</a> -->
                <a
                  class="newsList_des common_text"
                  @click="newsDetail(items.id)"
                  >{{ items.news_subject }}</a
                >
              </li>
            </ul>
          </div>
        </div>
      </el-col>
      <el-col
        :xs="24"
        :sm="12"
        :md="12"
        :lg="8"
        :xl="8"
        style="padding: 20px 10px"
      >
        <div class="newsList">
          <div class="newsList_title common_display">
            <p style="padding-bottom: 5px">
              <span
                class="newsTitleImgSrc common_backgroundImg"
                :style="'background-image:url(' + notices.newsTitleImgSrc + ')'"
              ></span>
              <span style="font-size: 18px">{{ notices.newsTitle }}</span>
            </p>
            <p style="padding-top: 5px">
              <router-link :to="notices.morePath">
                <a style="color: #b93229; cursor: pointer; font-size: 14px"
                  >查看更多&gt;</a
                >
              </router-link>
            </p>
          </div>
          <p class="line"></p>
          <div class="newsList_content">
            <ul>
              <li
                class="common_display"
                v-for="(items, index) in noticeList"
                :key="index"
              >
                <i class="radius"></i>
                <!-- <a :href="items.newsPath" class="newsList_des common_text">{{items.news_subject}}</a> -->
                <a
                  class="newsList_des common_text"
                  @click="noticeDetail(items.id)"
                  >{{ items.news_subject }}</a
                >
              </li>
            </ul>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Swiper from "swiper/swiper-bundle";
import {
  GetPhotoList,
  GetNewsList,
  GetNotificList,
} from "@/api/admin/common.js";

export default {
  name: "",
  data() {
    return {
      dataList: [],
      news: {
        newsTitle: "新闻动态",
        //newsTitleImgSrc: "/image/index/newsInfo.png",
        newsTitleImgSrc: "/image/new/newsInfo.png",
        morePath: "/news",
      },
      newsList: [],
      notices: {
        newsTitle: "通知公告",
        //newsTitleImgSrc: "/image/index/icon_Horn.png",
        newsTitleImgSrc: "/image/new/icon_Horn.png",
        morePath: "/notice",
      },
      noticeList: [],
      paging: {
        limit: 6,
        page: 1,
      },
      paging2: {
        limit: 6,
        page: 1,
      },
      id: 0,
      imgPath: window.apiObj.apiUrl,
    };
  },

  //   mounted() {
  //     this.creSwiper();
  //   },
  created() {
    this.getList();
  },
  methods: {
    //图片路径拼接
    getImgUrl(file_path) {
      var url = this.imgPath + file_path;
      return url;
    },
    getList() {
      // 新闻列表(展示图片)
      GetPhotoList({
        limit: 6,
        page: 1,
      }).then((data) => {
        var list = data.data.result;
        if (list) {
          this.dataList = list.items;
          this.creSwiper();
        }
      });
      // 新闻列表(无图)
      GetNewsList(Object.assign(this.paging2)).then((data) => {
        var list = data.data.result;
        if (list) {
          this.newsList = list.items;
        }
      });
      // 通知公告
      GetNotificList(Object.assign(this.paging)).then((data) => {
        var list = data.data.result;
        if (list) {
          this.noticeList = list.items;
        }
      });
    },
    //  新闻详情
    newsDetail(newsId) {
      this.id = newsId;
      this.$router.push({
        path: "/news/newsDetails",
        query: { id: this.id },
      });
    },
    //  公告详情
    noticeDetail(newsId) {
      this.id = newsId;
      this.$router.push({
        path: "/notice/noticeDetails",
        query: { id: this.id },
      });
    },
    creSwiper() {
      this.$nextTick(() => {
        this.swiper = new Swiper(".wheel_content", {
          loop: true,
          allowTouchMove: false,
          autoplay: {
            delay: 3000,
          },
          pagination: {
            el: ".swiper-pagination",
          },
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.newsInformation {
  .imgs {
    width: 100%;
    height: 240px;
    cursor: pointer;
  }

  .el-col {
    height: 240px;
    overflow: hidden;
  }

  .icon {
    width: 20px;
  }

  .newsTitleImgSrc {
    display: inline-block;
    width: 25px;
    height: 20px;
    position: relative;
    top: 3px;
    margin-right: 5px;
  }

  .newsList_title {
    color: #b93229;
  }

  .swiper-pagination {
    text-align: right;
    left: -10px;
  }

  .line {
    border-bottom: 1px solid #b93229;
  }

  .radius {
    display: inline-block;
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: #ea0000;
    position: relative;
    top: 13px;
    margin-right: 5px;
  }

  .newsList_des {
    display: inline-block;
    width: 100%;
    padding: 5px 5px;
    color: #000000;
    cursor: pointer;
  }
}
</style>
